import { devicesEntity } from "@entities/devices";
import { DEVICE_LIST } from "../../shared/configs/device-types";

type MockOptions = {
  deviceKey?: string;
  deviceId?: string | number;
  deviceName?: string;
  sensorId?: string | number;
  /** interval between sensor updates */
  intervalMs?: number;
  /** base value for sensor; waveform is added on top */
  baseValue?: number;
};

let mockInterval: number | null = null;
let mockTick = 0;

export function stopMock() {
  if (mockInterval != null) {
    window.clearInterval(mockInterval);
    mockInterval = null;
  }
}

export function runMock(options: MockOptions = {}) {
  stopMock();

  const {
    deviceKey = "PH (Bluetooth)",
    deviceId = "mock-device-1",
    deviceName = "Mock Bluetooth Device",
    sensorId = "mock-sensor-1",
    intervalMs = 500,
    baseValue = 7,
  } = options;

  const device = DEVICE_LIST.find((d) => d.key === deviceKey);
  if (!device) {
    // eslint-disable-next-line no-console
    console.warn(`[mock] Unknown deviceKey: "${deviceKey}"`);
    return;
  }

  // 1) make app think a device is connected
  devicesEntity.onDeviceConnected({ deviceId, deviceName });

  // 2) set chosen device type (skips DeviceSelection)
  devicesEntity.setDeviceInfo({ ...device, mode: "bluetooth" });

  // 3) optional: set a sane polling frequency for UI
  devicesEntity.setFrequency(10);

  // 4) start streaming fake sensor data
  mockTick = 0;
  mockInterval = window.setInterval(() => {
    mockTick += 1;

    // simple smooth-ish waveform
    const wave = Math.sin(mockTick / 8) * 0.6 + Math.sin(mockTick / 23) * 0.25;
    const jitter = (Math.random() - 0.5) * 0.05;
    const value = baseValue + wave + jitter;

    devicesEntity.onSensorDataUpdated({
      deviceId,
      sensorId,
      value,
      freq: 10,
      timestamp: new Date().toISOString(),
      deviceName,
      friendlyName: device.key,
      bufferSize: 1,
    });
  }, intervalMs);

  // Handy dev escape hatch in console
  // @ts-expect-error dev-only global
  window.__UNOVA_STOP_MOCK__ = stopMock;
}


